'use client';

import React, { useEffect } from 'react';
import { Box, Container, SimpleGrid, Text, Title } from '@mantine/core';
import { useResponsive } from '@/hooks/use-responsive';
import { MarkdownContent } from '@/app/page';
import Button from '../Button';
import ActivityIcon from '../../../public/img/icons/activity.svg';
import ChartIcon from '../../../public/img/icons/chart.svg';
import ChatBubbleIcon from '../../../public/img/icons/chat-bubble.svg';
import TimeCircleIcon from '../../../public/img/icons/time-circle.svg';
import FeatureSection from '../FeatureSection';

interface IconComponentProps {
  className?: string;
}

const iconMap: Record<string, React.ComponentType<IconComponentProps>> = {
  ChartIcon,
  ActivityIcon,
  ChatBubbleIcon,
  TimeCircleIcon,
};

interface ByLawsSectionProps {
  markdownContent?: MarkdownContent;
  py?: any;
}

export default function ByLawsSection({ markdownContent, py }: ByLawsSectionProps) {
  // const { content } = useSectionContent('by-laws');
  const content = markdownContent?.frontmatter;
  const { responsive } = useResponsive();

  useEffect(() => {
    // console.log('By Laws Section Markdown Content:', markdownContent);
  }, [markdownContent]);

  if (!content) return null;

  const features = content?.features?.map((feature: { icon: string; }) => ({
    ...feature,
    icon: React.createElement(iconMap[feature?.icon!], { className: "icon-shadow" })
  }));

  return (
    <FeatureSection
      py={responsive({
        xs: content?.layout?.padding?.xs,
        lg: content?.layout?.padding!.lg,
      })}
      title={content?.title!}
      subtitle={content?.subtitle!}
      features={features!}
      ctaButton={
        content.buttonText && (
          <Button href={content.buttonHref ?? '#'} variant="outline" hasArrow>
            {content.buttonText}
          </Button>
        )
      }
    />
  );
}